import {Routes} from '@angular/router';
import {RouteUtil} from '../util/route.util';

export const routes: Routes = [
    {
        path: RouteUtil.DASHBOARD_MODULE,
        loadChildren: () => import('./dashboard/dashboard.module').then(module => module.DashboardModule)
    }, {path: '**', redirectTo: '/', pathMatch: 'full'}
];
